// redux/slices/myGymTV/ukEntitiesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const ukEntitiesSlice = createSlice({
  name: 'ukEntities',
  initialState: {
    selectedClubs: [],
    expandedNetworks: [],
    expandedChains: [],
  },
  reducers: {
    toggleNetwork: (state, action) => {
      const networkId = action.payload.networkId;
      const index = state.expandedNetworks.indexOf(networkId);

      if (index > -1) {
        state.expandedNetworks.splice(index, 1);
      } else {
        state.expandedNetworks.push(networkId);
      }
    },

    toggleChain: (state, action) => {
      const chainId = action.payload.chainId;
      const index = state.expandedChains.indexOf(chainId);

      if (index > -1) {
        state.expandedChains.splice(index, 1);
      } else {
        state.expandedChains.push(chainId);
      }
    },

    selectNetwork: (state, action) => {
      const { networkId, allClubs } = action.payload;
      const networkClubs = allClubs.filter(club => club.NetworkId === networkId);

      state.selectedClubs = state.selectedClubs.filter(
        club => club.NetworkId !== networkId
      );

      state.selectedClubs.push(...networkClubs);
    },

    selectChain: (state, action) => {
      const { chainId, allClubs } = action.payload;
      const chainClubs = allClubs.filter(club => club.ChainId === chainId);

      state.selectedClubs = state.selectedClubs.filter(
        club => club.ChainId !== chainId
      );

      state.selectedClubs.push(...chainClubs);
    },

    toggleClub: (state, action) => {
      const club = action.payload;
      const index = state.selectedClubs.findIndex(c => c.ClubId === club.ClubId);

      if (index > -1) {
        state.selectedClubs.splice(index, 1);
      } else {
        state.selectedClubs.push(club);
      }
    },

    deselectNetwork: (state, action) => {
      const networkId = action.payload;
      state.selectedClubs = state.selectedClubs.filter(
        club => club.NetworkId !== networkId
      );
    },

    deselectChain: (state, action) => {
      const chainId = action.payload;
      state.selectedClubs = state.selectedClubs.filter(
        club => club.ChainId !== chainId
      );
    },

    clearSelections: (state) => {
      state.selectedClubs = [];
    }
  }
});

export const {
  toggleNetwork,
  toggleChain,
  selectNetwork,
  selectChain,
  toggleClub,
  deselectNetwork,
  deselectChain,
  clearSelections
} = ukEntitiesSlice.actions;

export default ukEntitiesSlice.reducer;
